// extracted by mini-css-extract-plugin
module.exports = {"nav":"breadcrumb_nav__AVAqv"};